import withFinalForm from "@/hocs/withFinalForm";

/** Re-export Inputs */
export { default as Input } from "./Base/Input";
export { default as Select } from "./Base/Select";
export { default as Textarea } from "./Base/Textarea";
export { default as Checkbox } from "./Field/Checkbox";
export { default as Slider } from "./Field/Slider";

/** Import Input defaults to re-export with FinalForm */
import Checkbox from "./Field/Checkbox";
import InputField from "./Field/InputField";
import SelectField from "./Field/SelectField";

/** Final Form Input exports */
export const FF_Checkbox = withFinalForm(Checkbox);
export const FF_InputField = withFinalForm(InputField);
export const FF_SelectField = withFinalForm(SelectField);
